import React from 'react';
import { Close } from '@mui/icons-material';
import { Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { MailOutlined } from '@mui/icons-material';
import { primaryButtonOutlinedColor } from '../../constants/Colors';

interface ModalProps {
  open: boolean;
  onClose: () => void;
}

const modalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      m: '16px',
      width: '560px',
      p: '24px'
    }
  }
};

export const InviteCompleteMemeberModal: React.FC<ModalProps> = (props) => {
  const { open, onClose } = props;

  return (
    <Dialog open={open} sx={modalStyles.dialog}>
      <Grid container justifyContent="flex-end">
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Grid>
      <Grid
        container
        flexDirection={'column'}
        alignItems={'center'}
        rowGap={'16px'}
      >
        <MailOutlined sx={{ width: '56px', height: '56px' }} />
        <Typography sx={{ fontSize: '24px' }}>
          招待メールを送信しました
        </Typography>
      </Grid>

      <Button
        onClick={onClose}
        sx={{
          ...primaryButtonOutlinedColor,
          boxSizing: 'border-box',
          mt: '40px'
        }}
        variant="outlined"
      >
        共有者一覧へ
      </Button>
    </Dialog>
  );
};
